import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  Checkbox,
  TextField,
  FormHelperText,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { Cross } from "../../shared/assets/icons/index";
import CustomInput from "../../shared/utils/Input";
import axios from "axios";
import Swal from "sweetalert2";
import "./vendorOnboard.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CustomButton from "../utils/Button";
import { IndiaState } from "../enums/indiaState";

const CampaignEditModal = ({
  campaignData,
  isEditModal,
  setIsEditModal,
  getCampaignList,
}) => {
  const [formData, setFormData] = useState({
    campaignTitle: campaignData?.campaignTitle || "",
    campaignOwnerId: campaignData?.campaignOwnerId || "",
    organizationId: campaignData?.organizationId || "",
    status: campaignData?.status || "",
    quantity: campaignData?.quantity || null,
    organizationName: campaignData?.organizationId?.name || "",
    ClientOwnerName: campaignData?.campaignOwnerId?.name || "",
    ClientOwnerEmailAddress: campaignData?.campaignOwnerId?.emailAddress || "",

    budget: campaignData?.budget || null,
    progress: campaignData?.progress || null,
    startDate: campaignData?.startDate ? dayjs(campaignData.startDate) : null,
    endDate: campaignData?.endDate ? dayjs(campaignData.endDate) : null,
    keyAccountManagerId: campaignData?.keyAccountManagerId || [""],
    locations: campaignData?.locations || [""],
  });
  const [disableSaveButton, setDisableSaveButton] = useState();

  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const serverURL = process.env.REACT_APP_URL;

  const [requiredFields, setRequiredFields] = useState({
    // campaignTitle: false,
    // status: false,
    // organizationName: false,
    // ClientOwnerName: false,
    // ClientOwnerEmailAddress: false,
    // budget: false,
    // progress: false,
    // startDate: false,
    // endDate: false,
    // locations: false,
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData.campaignTitle)
      newErrors.campaignTitle = "Campaign Title is required";
    if (!formData.startDate) newErrors.startDate = "Start Date is required";
    if (!formData.endDate) newErrors.endDate = "End Date is required";
    if (!formData.organizationName)
      newErrors.organizationName = "Company Name is required";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.ClientOwnerEmailAddress) {
      newErrors.ClientOwnerEmailAddress = "Campaign Owner Email is required";
    } else if (!emailRegex.test(formData.ClientOwnerEmailAddress)) {
      newErrors.ClientOwnerEmailAddress = "Invalid email format";
    }

    if (!formData.ClientOwnerName)
      newErrors.ClientOwnerName = "Campaign Owner Name is required";
    if (!formData.budget) newErrors.budget = "Budget is required";
    if (!formData.quantity) newErrors.quantity = "Quantity is required";
    if (!formData.status) newErrors.status = "Status is required";
    if (formData.locations.length == 0) {
      newErrors.locations = "Location is required";
    }
    // if (!formData.locations) newErrors.locations = "locations is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    setIsEditModal(false);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      // Handle top-level fields normally
      return {
        ...prevFormData,
        [name]: value,
      };
    });

    // Reset errors or perform validation here if needed
    setErrors({ ...errors });
  };

  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("skjfakj");

    if (!validateForm()) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "Something Went Wrong in Validation",
        color: "black",
      });
    } else {
      try {
        if (campaignData._id) {
          // Update existing vendor
          try {
            const updatedFormData = {
              ...formData,
            };
            setIsLoading(true);
            const response = await axios.put(
              `${serverURL}/campaign/editCampaign/${campaignData._id}`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );

            if (response.status === 200) {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "success",

                text: "Campaign Update Successfully!",
                padding: "1em",
                color: "black", // Corrected color value
              }).then(() => {
                setIsEditModal(false);
                getCampaignList();
              });
            }
          } catch (error) {
            console.log(error);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.message,
              text: `Error in updating Campaign: ${formData.vendorBusinessName}!`,
              padding: "1em",
            });
          }
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Dialog open={isEditModal} maxWidth="xl">
        <div className="flex justify-between">
          <DialogTitle>Campaign Form Update</DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent sx={{ maxWidth: 1200, margin: "auto" }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="campaignTitle"
                  placeholder="Enter Campaign Title"
                  title="Campaign Title*"
                  size="small"
                  required
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  errorMessage={
                    errors.CampaignTitle ? "Please Enter Campaign Title" : null
                  }
                  error={errors.CampaignTitle}
                  value={formData?.campaignTitle}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="organizationName"
                  placeholder="Enter Company Name"
                  title="Company Name*"
                  size="small"
                  required
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  errorMessage={
                    errors.organizationName ? (
                      <span style={{ color: "#ff5555" }}>
                        Please Enter Company Name
                      </span>
                    ) : null
                  }
                  error={errors.organizationName}
                  value={formData?.organizationName}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="ClientOwnerName"
                  placeholder="Enter Campaign Owner name"
                  title="Campaign Owner*"
                  size="small"
                  required
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  errorMessage={
                    errors.ClientOwnerName ? (
                      <span style={{ color: "#ff5555" }}>
                        Please Enter Company Owner Name
                      </span>
                    ) : null
                  }
                  error={errors.ClientOwnerName}
                  value={formData?.ClientOwnerName}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="ClientOwnerEmailAddress"
                  placeholder="Enter Campaign Owner Email"
                  title="Campaign Owner Email*"
                  size="small"
                  required
                  onChange={(e) => handleInputChange(e)}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  errorMessage={
                    errors.ClientOwnerEmailAddress ? (
                      <span style={{ color: "#ff5555" }}>
                        Please Enter Campaign Owner Email
                      </span>
                    ) : null
                  }
                  error={errors.ClientOwnerEmailAddress}
                  value={formData?.ClientOwnerEmailAddress}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <InputLabel className={`${errors.locations && "#36383A"}`}>
                  Locations *
                </InputLabel>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={errors.locations}
                  errorMessage={
                    errors.locations ? (
                      <span style={{ color: "var(--error-color)" }}>
                        Please Select locations
                      </span>
                    ) : null
                  }
                  value={formData?.locations}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="locations"
                    multiple // Enables multiple selection
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    value={formData?.locations || []} // Ensure `locations` is an array
                    onChange={(e) => {
                      const { value } = e.target;
                      handleInputChange({
                        target: { name: "locations", value },
                      });
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Locations
                          </p>
                        );
                      }
                      return selected.join(", ");
                    }}
                  >
                    {Object.keys(IndiaState["India"]).map((state) => (
                      <MenuItem key={state} value={state}>
                        <Checkbox
                          checked={formData?.locations?.includes(state)}
                        />
                        <ListItemText primary={state} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.locations && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-red-500">
                    {errors.locations}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <div className="flex flex-col ">
                  <label
                    style={{
                      marginBottom: "6px",
                      display: "block",
                      color: "#36383A",
                    }}
                  >
                    Start Date*
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Start Date"
                      className="p-2"
                      value={formData.startDate || null}
                      onChange={(date) => {
                        handleInputChange({
                          target: { name: "startDate", value: date },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={errors.startDate} // Show error style if true
                          helperText={errors.startDate && "Select Start Date"}
                        />
                      )}
                      required
                      error={errors.startDate}
                      errorMessage={errors.startDate}
                    />
                  </LocalizationProvider>
                  {errors.startDate && (
                    <FormHelperText
                      className="text-[var(--error-color)] text-[12px] mt-3 ml-3"
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      Select Start Date
                    </FormHelperText>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <div className="flex flex-col   ">
                  <label
                    style={{
                      marginBottom: "6px",
                      fontWeight: "400",
                      color: "#36383A",
                    }}
                  >
                    End Date*
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Last Date"
                      value={formData.endDate || null} // Controlled value
                      minDate={formData.startDate || null}
                      onChange={(date) =>
                        handleInputChange({
                          target: { name: "endDate", value: date },
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} fullWidth />
                      )}
                      required
                    />
                  </LocalizationProvider>
                  {errors.endDate && (
                    <FormHelperText
                      className="text-[var(--error-color)] text-[12px] mt-3 ml-3"
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      Select End Date
                    </FormHelperText>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <InputLabel
                  className={`${errors.status && "text-[var(--error-color)]"}`}
                >
                  Status *
                </InputLabel>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={!!errors.status} // Boolean for error state
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) {
                      validateForm();
                    }
                  }}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="status"
                    value={formData?.status || ""}
                    onChange={handleInputChange}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Status
                          </p>
                        );
                      }
                      return selected;
                    }}
                  >
                    {/* Gender options */}
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Close">Close</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                  </Select>
                </FormControl>

                {errors.status && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.status}
                  </p>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <InputLabel
                  className={`${errors.status && "text-[var(--error-color)]"}`}
                >
                  Progress *
                </InputLabel>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={!!errors.status} // Boolean for error state
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) {
                      validateForm();
                    }
                  }}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="progress" // Set to "progress" to match formData field
                    value={formData.progress || ""}
                    onChange={handleInputChange}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Progress
                          </p>
                        );
                      }
                      return `${selected}%`; // Display selected value with percentage sign
                    }}
                  >
                    <MenuItem value={20}>20%</MenuItem>
                    <MenuItem value={50}>50%</MenuItem>
                    <MenuItem value={100}>100%</MenuItem>
                  </Select>
                </FormControl>

                {errors.status && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.status}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="budget"
                  placeholder="Enter Budget"
                  title="Budget*"
                  type="number"
                  size="small"
                  onChange={(e) => {
                    if (
                      !e.target.value.startsWith(" ") &&
                      e.target.value.length < 7
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  value={formData?.budget}
                  errorMessage={
                    errors.budget ? (
                      <span style={{ color: "#ff5555" }}>
                        Please Enter Budget
                      </span>
                    ) : null
                  }
                  error={errors.budget}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <CustomInput
                  name="quantity"
                  placeholder="Enter Quantity"
                  title="Quantity*"
                  type="number"
                  size="small"
                  onChange={(e) => {
                    if (
                      !e.target.value.startsWith(" ") &&
                      e.target.value.length < 7
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  onBlur={(e) => {
                    emptyInputCheck(e.target.name, e.target.value);
                    if (saveButtonClicked) validateForm();
                  }}
                  value={formData?.quantity}
                  errorMessage={
                    errors.quantity ? (
                      <span style={{ color: "#ff5555" }}>
                        Please Enter Quantity
                      </span>
                    ) : null
                  }
                  error={errors.quantity}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <CustomButton
            type="submit"
            isLoading={isLoading}
            disabled={disableSaveButton}
            text={campaignData._id ? "Update" : "Save"}
            color="primary"
            onClick={(e) => {
              // setIsLoading(true)
              setSaveButtonClicked(true);
              handleSubmit(e);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CampaignEditModal;
